<template>
    <v-radio-group label="Search mode" v-model="value" @change="$emit('update:is-pattern', $event)">
        <template v-slot:label><slot></slot></template>
        <v-radio label='exact match' :value="false"></v-radio>
        <v-radio label='partial match' :value="true"></v-radio>
    </v-radio-group>
</template>

<script>
export default {
    name: 'SearchModeSelector',
    props: {
        isPattern: Boolean
    },
    data:
        function() {
            return {
                value: this.isPattern
            }
        }
}
</script>